import React, {useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import Switch from "react-bootstrap-switch";

import {
    error,
    FORM,
    infoMsg,
} from "../../../components/i18n/i18n";
import { showLoader } from "../../../components/loader/loader";
import {
    ButtonCancel,
    ButtonEdit,
    ButtonNew,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import { webCamService } from "../../../jwt/_services/hotel/webCamService";
import {showToastCustom} from "../../../components/toast/customToast";
import SelectGeneric from '../../../components/select/selectGeneric';
import { hotelCategoryProvider } from "../../../providers/hotelCategoryProvider";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";

const WebCamForm = ( props ) => {
    const [loading, setLoading] = useState(false);
    const [editMode, setEditMode] = useState(!!props?.item?.id);
    const [savedData, setSavedData] = useState(editMode ? props.item : null);

    const [status, setStatus] = useState(editMode ? props.item?.status : false);
    const [category, setCategory] = useState(editMode ? props.item?.category : null)
    const [, setChildChanges] = useState(false);
    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(savedData);
    }

    //Formulario
    const [disableInputs, setDisableInputs] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const validationSchema = Yup.object().shape({});
    const {register, handleSubmit, reset} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id          : savedData?.id,
            uid         : savedData?.uid,
            code        : savedData?.code,
            status      : savedData?.status,
            image       : savedData?.image,
            name        : savedData?.name,
            showOrder   : savedData?.showOrder,
            url         : savedData?.url,
            videoId     : savedData?.videoId,
            
        }
    });
    
    const onSubmit = (data, _) => {
        let info = JSON.parse(JSON.stringify(data))

        info.category = category
        info.status = status
       
        setLoading(true);

        if (!editMode) {
            return webCamService.saveItem(info).then(resultData => {
                setResult(resultData);
                setLoading(false);
            }).catch(errorMessage => {
                setLoading(false);
                showToastCustom(error, errorMessage);
            });
        } else {
            let id = savedData.id;
            delete savedData.id;
            
            if (JSON.stringify(savedData) === JSON.stringify(info)){
                setLoading(false);
                return showToastCustom(info, infoMsg);
            }

            info = { ...info, id }
            
            return webCamService.updateItem(id, info).then(resultData => {
                setResult(resultData);
                setLoading(false);
            }).catch(errorMessage => {
                setLoading(false);
                showToastCustom(error, errorMessage);
            });
        }
    };


    const setResult = (resultData) => {
        setLoading(false);
        setSavedData(resultData);
        setDisableInputs(true);
        setSaveSuccess(true);
        setEditMode(true);
    }

    const resetForm = () => {
        setSavedData(null);
        setStatus(false);
        setEditMode(false);
        setDisableInputs(false);
        setSaveSuccess(false);
        setChildChanges(false);
        reset();
    }

    const beginEdit = () => {
        setEditMode(true);
        setSaveSuccess(false)
        setDisableInputs(false);
        setChildChanges(false);
    }

    const setForm = () => {
        props.setForm(null, null, "LIST");
    }


    return (
        <Card>
            { loading ? showLoader() : null }

            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={ handleSubmit(onSubmit) }>
                    {
                        editMode &&  <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label>ID</Label>
                                    <Input 
                                        type="id" 
                                        name="id" 
                                        id="id"
                                        disabled
                                        value={ editMode ? savedData?.id : '' }
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <FormGroup>
                                        <Label>UID Firebase</Label>
                                        <Input 
                                            type="id" 
                                            name="uid" 
                                            id="uid"
                                            disabled
                                            value={ editMode ? savedData?.uid : '' }
                                        />
                                    </FormGroup>
                                </FormGroup>
                            </Col>
                        </Row>
                    }
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label>Código</Label>
                                <Input 
                                    type="text" 
                                    name="code"
                                    placeholder="Código"
                                    innerRef={register}
                                    disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col  md="3">
                            <FormGroup>
                                <Label>Activo</Label>
                                <br/>
                                <Switch 
                                    animate={true} 
                                    offText={"No"} 
                                    onText={"Si"}
                                    value={ status }
                                    disabled={ disableInputs }
                                    onChange={ value => setStatus(!status) }
                                />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>Categoría</Label>
                                <br/>
                                <SelectGeneric 
                                    isDisabled={ disableInputs }
                                    initialValue={ category?.id }
                                    setExternalValue={ setCategory }
                                    provider={ hotelCategoryProvider }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Nombre</Label>
                                <Input 
                                    type="text" 
                                    name="name"
                                    placeholder="Nombre"
                                    innerRef={register}
                                    disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>Imagen</Label>
                                <Input 
                                    type="text" 
                                    name="image"
                                    placeholder="Imagen"
                                    innerRef={register}
                                    disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>Orden</Label>
                                <Input 
                                    type="number" 
                                    name="showOrder"
                                    placeholder="Orden"
                                    min="1"
                                    innerRef={register}
                                    disabled={disableInputs}
                                    />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Url</Label>
                                <Input 
                                    type="text" 
                                    name="url"
                                    placeholder="Url"
                                    innerRef={register}
                                    disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>VideoId</Label>
                                <Input 
                                    type="text" 
                                    name="videoId"
                                    placeholder="VideoId"
                                    innerRef={register}
                                    disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardBody className="border-top">
                        {
                            saveSuccess ?
                                <div className="float-right">
                                    <ButtonNew onClick={() => resetForm() }/>
                                    <ButtonEdit onClick={() => beginEdit() }/>
                                    <ButtonCancel onClick={ setForm }/>
                                </div>
                                : <div className="float-right">
                                    <ButtonSubmit/>
                                    <ButtonCancel onClick={ setForm }/>
                                </div>
                        }
                    </CardBody>
                </Form>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ savedData }
                />
            }
        </Card>
    )
}

export default WebCamForm
